/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Rounds_UnitInputs */



/**
* | output |
* | --- |
* | "rounds" |
*
* @param {Player_Rounds_UnitInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const player_rounds_unit = /** @type {((inputs?: Player_Rounds_UnitInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Rounds_UnitInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("rondes")
	if (locale === "es") return /** @type {LocalizedString} */ ("rondas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("rodadas")
	if (locale === "it") return /** @type {LocalizedString} */ ("round")
	return /** @type {LocalizedString} */ ("rounds")
});